import { createFileRoute } from '@tanstack/react-router'
import { UserRoundIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/admin')({
  staticData: {
    title: 'Admin',
    crumb: 'Admin',
    icon: UserRoundIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
